import { type FC, type SVGProps } from 'react';

/**
 * Phosphor HandSwipeLeft (MIT). Inline JSX so `stroke="currentColor"` picks
 * up the parent's CSS `color` — `<img src="...svg">` doesn't propagate
 * `color` to the embedded SVG document.
 */
export const HandSwipeLeftIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M64,216,34.68,166a20,20,0,0,1,34.64-20L88,176V68a20,20,0,0,1,40,0v56a20,20,0,0,1,40,0v16a20,20,0,0,1,40,0v36c0,24-8,40-8,40"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
    <line
      x1={176}
      y1={56}
      x2={248}
      y2={56}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
    <polyline
      points="208 24 176 56 208 88"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={16}
    />
  </svg>
);

HandSwipeLeftIcon.displayName = 'HandSwipeLeftIcon';
